<div fxFlex="100" fxLayout="column" fxLayoutGap='15px' >
  <mat-card class="mat-elevation-z4" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
    <div fxFlex="100" fxLayout="row"  fxLayoutAlign="space-around center">

      <h2 fxFlex="100" fxLayoutAlign="space-around center">Formularz weryfikacji procesu sprzedaży</h2>

    </div>



    <div fxFlex="100" fxLayout="column" fxLayoutGap='15px'>

      <div fxFlex="100" fxLayout="row">
  <!--      <app-dict-ofwcas fxFlex="100"-->
  <!--                       [multiple]="true" label="OFWCA"   [ofwcaItems]="items"  [control]="ofwcasControl"-->
  <!--      ></app-dict-ofwcas>-->

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="partnerFacilityVerificationSalesProcess.ofwcas.length > 0">
          <div fxFlex="100">
            <app-detail header="OFWCA biorące udział w kontroli ">
              <mat-chip-list>
                <ng-container *ngFor="let ofwca of partnerFacilityVerificationSalesProcess.ofwcas; let last = last">
                  <mat-chip color="accent" selected  [routerLink]="ofwca ? ['/ofwca/szczegoly', ofwca.uuid] : undefined" >{{ofwca.fullName}} </mat-chip>
                </ng-container>
              </mat-chip-list>
            </app-detail>
          </div>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row">
        <br>
        Forma weryfikacji: Obserwacja OFWCA w trakcie realizacji procesu sprzedaży
        <br><br><br>
      </div>

    </div>

    <div fxFlex="100" fxLayout="column" fxLayoutGap='15px' >


      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60">
          <b>
            Weryfikowany element - każdy element powinien być możliwy do udowodnienia przez OFWCA za pomocą obiektywnych środków dowodowych innych niż oświadczenie ustne OFWCA
          </b>
        </div>
        <div fxFlex="10"  fxLayoutAlign="center">
          <b> NIE/TAK </b>
        </div>
        <div fxFlex="30">
          <b>
          Inne zastrzeżenia bądź uwagi powiązane z weryfikowanym elementem
          </b>
        </div>
      </div>


      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60" > Czy OFWCA posługuje się aktualną i poprawną klauzulą IDD? </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool0" ></app-detail-bool>
        </div>
        <div fxFlex="30">
            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value0">{{partnerFacilityVerificationSalesProcess.value0}}</textarea>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA posługuje się aktualnymi  i poprawnymi  pełnomocnictwami  agencyjnymi? </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool1" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value1">{{partnerFacilityVerificationSalesProcess.value1}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60" > Czy OFWCA posługuje się aktualnymi  i poprawnymi  upoważnieniami OFWCA?</div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool2" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value2">{{partnerFacilityVerificationSalesProcess.value2}}</textarea>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA udostępnia do zapoznania się każdemu Klientowi klauzulę IDD w formie papierowej lub innnego trwałego nośnika?</div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool3" ></app-detail-bool>
        </div>
        <div fxFlex="30">
            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value3">{{partnerFacilityVerificationSalesProcess.value3}}</textarea>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA udostępnia do zapoznania się każdemu Klientowi pełnomocnictwa agencyjne oraz upoważnienia OFWCA?</div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool4" ></app-detail-bool>
        </div>
        <div fxFlex="30">
            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value4">{{partnerFacilityVerificationSalesProcess.value4}}</textarea>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA prowadzi analizę wymagań i potrzeb Klienta w każdym przypadku sprzedaży? </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool5" ></app-detail-bool>
        </div>
        <div fxFlex="30">
            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value5">{{partnerFacilityVerificationSalesProcess.value5}}</textarea>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA posługuje się aktualnymi wzorami OWU oraz IPID (Karta Produktu) do każdego produktu? </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool6" ></app-detail-bool>
        </div>
        <div fxFlex="30">
            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value6">{{partnerFacilityVerificationSalesProcess.value6}}</textarea>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy używana przez OFWCA Karta Produktu jest odrębnym od OWU dokumentem?</div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool7" ></app-detail-bool>
        </div>
        <div fxFlex="30">
            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value7">{{partnerFacilityVerificationSalesProcess.value7}}</textarea>
        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy każdy Klient otrzymuje od OFWCA OWU i Kartę Produktu?  </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool8" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value8">{{partnerFacilityVerificationSalesProcess.value8}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy Klient za każdym razem otrzymuje polisę papierową lub w formie innego trwałego nośnika?</div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool9" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value9">{{partnerFacilityVerificationSalesProcess.value9}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy po zakończonym procesie sprzedaży Klient otrzymuje pakiet dokumentów - polisę lub jej skan, OWU, IPID? </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool10" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value10">{{partnerFacilityVerificationSalesProcess.value10}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy dokumentacja procesu sprzedaży została zarchiwizowana u OFWCA?  </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool11" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value11">{{partnerFacilityVerificationSalesProcess.value11}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy w weryfikowanych produktach znajdował się produkt życiowy? </div>
        <div fxFlex="10"  fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool12" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value12">{{partnerFacilityVerificationSalesProcess.value12}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy w przypadku sprzedaży  produktu życiowego zastosowano w pełni procedurę AML? </div>
        <div fxFlex="10"  fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool12a" ></app-detail-bool>
        </div>
        <div fxFlex="30">

          <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value12a">{{partnerFacilityVerificationSalesProcess.value12a}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy OFWCA przestrzega zakazu, o którym mowa w art. 25 UDU? </div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool17" ></app-detail-bool>
        </div>
        <div fxFlex="30">

          <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value17">{{partnerFacilityVerificationSalesProcess.value17}}</textarea>

        </div>
      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
        <div fxFlex="60"> Czy stwierdzono inne nieprawidłowości nieuwzględnione w ankiecie?</div>
        <div fxFlex="10" fxLayoutAlign="center">
          <app-detail-bool [value]="partnerFacilityVerificationSalesProcess.bool13" ></app-detail-bool>
        </div>
        <div fxFlex="30">

            <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value13">{{partnerFacilityVerificationSalesProcess.value13}}</textarea>

        </div>
      </div>

    </div>

    <div fxFlex="100" fxLayout="row" fxLayoutGap='15px'>
      <div fxFlex="30"> Opis realizacji zaleceń z poprzedniej kontroli z dnia </div>
      <div fxFlex="70">

          <textarea fxFlex="100" [disabled]="true" *ngIf="partnerFacilityVerificationSalesProcess.value15">{{partnerFacilityVerificationSalesProcess.value15}}</textarea>

      </div>
    </div>

  </mat-card>
</div>
